import { gql } from "@apollo/client";

export const SEND_MESSAGE_MUTATION = gql`
  mutation ChatSendMessage($input: ChatSendMessageInput!) {
    chatSendMessage(input: $input) {
      id
    }
  }
`;

export const NEW_DM_MUTATION = gql`
  mutation ChatNewDirectMessage($input: ChatNewDirectMessageInput!) {
    chatNewDirectMessage(input: $input) {
      id
    }
  }
`;

export const STREAM_FLAG_MESSAGE = gql`
  mutation streamFlagMessage($input: StreamFlagMessageInput!) {
    streamFlagMessage(input: $input)
  }
`;
